import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertTriangle, Trash2 } from 'lucide-react';
import { cn } from '../lib/cn.js';
import { Button } from './Button.js';
import { Dialog } from './Dialog.js';
const toneTile = {
    danger: 'bg-danger-soft text-danger',
    warn: 'bg-warn-soft text-warn',
    accent: 'bg-accent-soft text-accent',
};
const toneButton = {
    danger: 'danger',
    warn: 'primary',
    accent: 'primary',
};
/**
 * Tasdiqlash oynasi.
 *
 * Loyihada bu shakl OLTITA ekranda qo'lda takrorlangan edi: `Dialog size="sm"`
 * + matn + `ghost` bekor qilish + `danger` tasdiq. Har nusxada bo'shliq,
 * tugma tartibi va matn o'lchami bir-biridan biroz farq qilardi — ya'ni
 * bir xil savol har joyda boshqacha ko'rinardi.
 *
 * `Dialog` ning `headless` rejimidan foydalanadi: savol markazda, belgi
 * ostida turadi va tepada yana bir sarlavha bo'lishi uni ikki marta
 * aytish bo'lardi.
 */
export const ConfirmDialog = ({ open, onClose, onConfirm, title, description, confirmLabel, cancelLabel, tone = 'danger', loading = false, icon, error, }) => (_jsx(Dialog, { open: open, onClose: onClose, title: title, size: "sm", headless: true, busy: loading, error: error, onSubmit: loading ? undefined : onConfirm, footer: _jsxs(_Fragment, { children: [cancelLabel === undefined ? null : (_jsx(Button, { variant: "ghost", onClick: onClose, disabled: loading, children: cancelLabel })), _jsx(Button, { variant: toneButton[tone], loading: loading, onClick: onConfirm, children: confirmLabel })] }), children: _jsxs("div", { className: "flex flex-col items-center gap-4 text-center", children: [_jsx("span", { "aria-hidden": true, className: cn('flex size-12 shrink-0 items-center justify-center', 'rounded-[var(--radius-md)]', toneTile[tone]), children: icon ?? (tone === 'danger' ? _jsx(Trash2, { size: 22 }) : _jsx(AlertTriangle, { size: 22 })) }), _jsxs("div", { className: "flex flex-col gap-1.5", children: [_jsx("p", { className: "text-lg font-semibold tracking-tight text-text", children: title }), description ? _jsx("p", { className: "text-sm text-text-muted", children: description }) : null] })] }) }));
//# sourceMappingURL=ConfirmDialog.js.map